import { Outlet } from 'react-router-dom'

import { ModuleListSearchProvider } from 'modules/marketplace_modules/components/List/ModuleListSearchProvider'
import CollectionsBootstrap from 'modules/marketplace_modules/lib/CollectionsBootstrap'

const ModulesRootPage = () => {
  return (
    <CollectionsBootstrap>
      <ModuleListSearchProvider>
        <Outlet />
      </ModuleListSearchProvider>
    </CollectionsBootstrap>
  )
}

export default ModulesRootPage
